import React from 'react';
import { hackyServerSideTranslations } from '../i18nNext';
import HomePageFreelance from '../components/homePage/HomePageFreelance';
import { buildGuestOrLoggedInLayout } from '../components/layout/layoutBuilder';
import { buildSimpleHead, PAGES_WITH_CUSTOM_HEADER } from '../components/layout/heading';
import { cdnize } from '../utils/pureUtils';

const { FREELANCER } = PAGES_WITH_CUSTOM_HEADER;
const FreelancerPage = () => {
  return <HomePageFreelance />;
};

export async function getStaticProps({ locale }) {
  const i18nConfig = await hackyServerSideTranslations(locale, [
    'home',
    'betaBanner',
    'common',
    'metaData',
    'auth',
    'testimonials',
    'homePageFreelancer',
    'footer',
    'legal'
  ]);
  return { props: { ...i18nConfig } };
}

FreelancerPage.getHead = () => props => {
  const DefaultHeader = buildSimpleHead(FREELANCER);

  const imageLink = cdnize('/meta/freelancer-home-meta.jpg');

  return <DefaultHeader {...props} twitterImageLink={imageLink} imageLink={imageLink} />;
};

FreelancerPage.getLayout = buildGuestOrLoggedInLayout();
export default FreelancerPage;
